import React, { useState } from 'react';

const Announcements = ({ announcement, announcements }) => {
  const [isPaused, setIsPaused] = useState(false);
  const allAnnouncements = announcements || (announcement ? [announcement] : []);
  const hasAnnouncements = allAnnouncements.length > 0;
  const shouldScroll = allAnnouncements.length > 1;

  return (
    <div className="mt-8 mb-6">
      <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-4 shadow-temple lotus-border mb-4">
        <h3 className="text-2xl font-bold text-saffron text-center">
          Latest Announcements
        </h3>
      </div>
      <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-temple lotus-border relative overflow-hidden">
        <div
          className={`relative ${shouldScroll ? 'cursor-pointer' : ''}`}
          style={{height: '400px'}}
          onClick={() => shouldScroll && setIsPaused(!isPaused)}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_ef1b1145-f8f0-4391-9cb1-5b2f821776b0/artifacts/qd1ox15q_1000008845.png"
            alt="Peacock feather and lotus"
            className="w-full h-full object-cover rounded-lg"
          />
          <div className="absolute inset-0 flex items-center justify-center overflow-hidden p-6">
            {hasAnnouncements ? (
              shouldScroll ? (
                <div className={`notifications-text-scroll ${isPaused ? 'paused' : ''}`} style={{display: 'flex', flexDirection: 'column'}}>
                  <div className="flex flex-col gap-4 items-center">
                    {allAnnouncements.map((item, index) => (
                      <div key={index} className="bg-saffron/90 px-6 py-3 rounded-lg shadow-lg w-full">
                        <p className="text-base md:text-lg font-bold text-left text-black">
                          {item}
                        </p>
                      </div>
                    ))}
                  </div>
                  <div className="flex flex-col gap-4 items-center mt-4">
                    {allAnnouncements.map((item, index) => (
                      <div key={`dup-${index}`} className="bg-saffron/90 px-6 py-3 rounded-lg shadow-lg w-full">
                        <p className="text-base md:text-lg font-bold text-left text-black">
                          {item}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="bg-saffron/90 px-6 py-4 rounded-lg shadow-lg w-full">
                  <p className="text-base md:text-lg font-bold text-left text-black">
                    {allAnnouncements[0]}
                  </p>
                </div>
              )
            ) : (
              <div className="bg-saffron/90 px-6 py-3 rounded-lg shadow-lg">
                <p className="text-base md:text-lg font-bold text-center text-black">
                  No announcements at this time
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {shouldScroll && (
        <p className="text-sm text-gray-700 text-center mt-2 font-bold">Click to {isPaused ? 'resume' : 'pause'} scrolling</p>
      )}
    </div>
  );
};

export default Announcements;
